module.exports = __webpack_public_path__ + "static/media/preview.a42af420.webp";